import { defineAsyncComponent } from 'vue';

const SummaryInitialRegularDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialDetail/SummaryInitialRegularDetail.vue'),
);

const SummaryInitialProjectDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialDetail/SummaryInitialProjectDetail.vue'),
);

const SummaryInitialBaseDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstimateInitial/summaryInitialDetail/SummaryInitialBaseDetail.vue'),
);

const SummaryInitialExplanationSalaryDetailPopup = defineAsyncComponent(() =>
  import('@/views/summaryAudit/summaryAuditInitial/SummaryInitialExplanationSalaryDetailPopup.vue'),
);

export function registerSummaryEstimateInitial(app) {
  app.component('SummaryInitialRegularDetail', SummaryInitialRegularDetail);
  app.component('SummaryInitialProjectDetail', SummaryInitialProjectDetail);
  app.component('SummaryInitialBaseDetail', SummaryInitialBaseDetail);
  app.component('SummaryInitialExplanationSalaryDetailPopup', SummaryInitialExplanationSalaryDetailPopup);
}
